export function titleCaseChange(text = "") {
  return text
    .trim() // Remove leading & trailing spaces
    .split(/\s+/) // Split by one or more spaces
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
